import { Route, Routes } from 'react-router-dom';

import { WorkspacePage } from '../pages/WorkspacePage';

export const StyleRoutes = () => {
    return (
        <Routes>
            {/* <Route element={<DefaultLayout />}> */}
            <Route path="" element={<WorkspacePage />} />
            {/* </Route> */}
        </Routes>
    );
};
